import { environment } from '@environments/environment';
import { ConfigInterface } from './config.interface';

export type ConfigState = ConfigInterface;

export const initialConfigState: ConfigState = {
  ...window['NAConfig'],
  ...environment,
};
